module.exports = __webpack_public_path__ + "b1ab070ba3a729451ca323e4e36147d3.svg";